const winningMethod = {
    BonusGame: 'BonusGame',
    CancelledBet: 'CancelledBet',
    Cashin: 'Cashin',
    Normal: 'Normal',
    ReturnedBet: 'ReturnedBet'
};
export const { BonusGame, CancelledBet, Cashin, Normal, ReturnedBet } = winningMethod;
export default winningMethod;
